import React from "react";
import styled from "styled-components";
import IconeWpp from "../../assets/img/icone-wpp.png"

export default function FloatWppIcon() {
  return (
    <Wrapper>
      <a href="https://api.whatsapp.com/send?phone=5548991810053" target="_blank" rel="noreferrer">
        <img src={IconeWpp} alt="Ícone WhatsApp" />
      </a>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: fixed;
  z-index: 99;
  opacity: 0.9;
  bottom: 8px;
  right: 15px;

  img {
    width: 50px;
    height: auto;
  }
`;
